import { destroy, mutate, query, update, uploadFile } from "../../defaults/fetch";
import { useState, useEffect } from "react";

// Get all categories
export const getCategories = async () => {
  const url = `categories/`;
  const { data } = await query(url, {});
  return data;
}

export const useGetAllCategories = (flag) => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getAllCategories = async () => {
      setLoading(true);
      const url = `categories`;
      const { data } = await query(url, {});
      setLoading(false);
      setCategories(data);
    }
    getAllCategories();
  }, [flag])

  return { loading, categories };
}

export const useCreateCategory = () => {
  const createCategory = async (body) => {
    const url = `categories`;
    const { message } = await mutate(url, true, body);
    return message;
  }
  return createCategory;
}

export const useUpdateCategory = () => {
  const updateCategory = async (id, body) => {
    const url = `categories/${id}`;
    const { message } = await update(url, body);
    return message;
  }
  return updateCategory;
}

export const useDeleteCategory = () => {
  const deleteCategory = async (id) => {
    const url = `categories/${id}`;
    const { message } = await destroy(url);
    return message;
  }
  return deleteCategory;
}
